import React from 'react';
import { primaryColor, secondaryColor } from '../../../utils/comon';

const ToggleSwitch = ({ label, checked, onChange }) => {
    return (
        <label className="flex items-center cursor-pointer">
            <div className="relative">
                <input 
                    type="checkbox" 
                    className="sr-only" 
                    checked={checked} 
                    onChange={(e) => onChange(e.target.checked)} 
                />
                <div className={`block w-8 h-4 rounded-full transition-colors ${checked ? '' : 'bg-gray-300'}`} style={{ backgroundColor: checked ? primaryColor() : '' }}></div>
                <div className={`dot absolute left-0.5 top-0.5 bg-white w-3 h-3 rounded-full transition-transform ${checked ? 'transform translate-x-4' : ''}`}></div>
            </div>
            {label && <div className="ml-2 text-xs font-bold text-gray-700 dark:text-textprimary">{label}</div>}
        </label>
    );
};

export default ToggleSwitch;
